module.exports = __webpack_public_path__ + "img/1f971.3c52a14.svg";